import { forEach, get } from 'lodash'

/**
 * Sync form values parameters to query string.
 * @param {Object<string, any>} formValues
 */
export const syncFormToQueryString = (formValues) => {
  const location = get(window, 'location', null)
  if (location) {
    const url = new URL(location)
    forEach(formValues, (value, key) => {
      if (value !== '') url.searchParams.set(key, value)
      else url.searchParams.delete(key)
    })

    window.history.pushState(null, null, url.href)
  }
}
